export default __webpack_public_path__ + "media/images/admin/backup-fonts-48ddf2d530f39058a61dc5f1cdf080bc.png";